let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("fvv3N")]).then(() => parcelRequire('11i6T'));